import { io } from 'socket.io-client';

let socket;

export const connectSocket = (token) => {
  if (!token) return null;
  if (socket?.connected) return socket;
  const baseUrl = (process.env.REACT_APP_API_URL || '/api').replace(/\/api\/?$/, '');
  socket = io(baseUrl || window.location.origin, {
    transports: ['websocket'],
    auth: { token },
  });
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
